import {
  AiMagicToolIcon,
  BlockQuoteIcon,
  BoardOne,
  BulletedList,
  CalloutIcon,
  CodeIcon,
  DateIcon,
  EmbedIcon,
  HeadingOneIcon,
  HeadingThreeIcon,
  HeadingTwoIcon,
  ImageIcon,
  LinkFileIcon,
  NumberedList,
  TableIcon,
  TaskIcon,
  TextIcon,
  TodoLiIcon,
} from '@sketchnote/icons';
import {
  ELEMENT_AI_CONTENT,
  ELEMENT_BOARD,
  ELEMENT_CALLOUT_TIP,
  ELEMENT_CODE_HIGHLIGHT_BLOCK,
  ELEMENT_DATE_TODAY,
  ELEMENT_EMBED,
  ELEMENT_FILE,
  ELEMENT_MICRO_TASK,
  ELEMENT_TABLE_PLUS,
} from '@sketchnote/slate-plugins';
import {
  ELEMENT_BLOCKQUOTE,
  ELEMENT_DEFAULT,
  ELEMENT_H1,
  ELEMENT_H2,
  ELEMENT_H3,
  ELEMENT_IMAGE,
  ELEMENT_OL,
  ELEMENT_TODO_LI,
  ELEMENT_UL,
} from '@udecode/plate';
import { frontendHostUrl } from 'config';

const _weapons = [
  {
    value: 'text',
    type: ELEMENT_DEFAULT,
    name: 'Text',
    icon: TextIcon,
    subText: 'Simply start typing',
  },
  {
    value: 'heading-1',
    name: 'Heading 1',
    icon: HeadingOneIcon,
    type: ELEMENT_H1,
    subText: 'For big headings',
  },
  {
    value: 'heading-2',
    name: 'Heading 2',
    icon: HeadingTwoIcon,
    type: ELEMENT_H2,
    subText: 'For medium headings',
  },
  {
    value: 'heading-3',
    name: 'Heading 3',
    icon: HeadingThreeIcon,
    type: ELEMENT_H3,
    subText: 'For small headings',
  },
  {
    value: 'callout',
    name: 'Callout',
    icon: CalloutIcon,
    type: ELEMENT_CALLOUT_TIP,
    subText: 'Highlight a line',
  },
  {
    value: 'micro-task',
    name: 'Task',
    icon: TaskIcon,
    type: ELEMENT_MICRO_TASK,
    subText: 'Create and assign tasks',
  },
  {
    value: 'todo-list',
    name: 'Todo List',
    icon: TodoLiIcon,
    type: ELEMENT_TODO_LI,
    subText: 'Start noting down tasks',
  },
  {
    value: 'table-plus',
    name: 'Table',
    icon: TableIcon,
    type: ELEMENT_TABLE_PLUS,
    subText: 'Add a table to the page',
  },
  // {
  //   value: 'board',
  //   name: 'Board',
  //   icon: BoardOne,
  //   type: ELEMENT_BOARD,
  //   subText: 'Add a Kanban board to your page',
  // },
  {
    value: 'codeblock',
    name: 'Code block',
    icon: CodeIcon,
    type: ELEMENT_CODE_HIGHLIGHT_BLOCK,
    subText: 'Write a piece of code ',
  },
  {
    value: 'blockquote',
    name: 'Quote',
    icon: BlockQuoteIcon,
    type: ELEMENT_BLOCKQUOTE,
    subText: 'Showcase a quote',
  },

  {
    value: 'bulleted-list',
    name: 'Bulleted list',
    icon: BulletedList,
    type: ELEMENT_UL,
    subText: 'Make pointers quickly',
  },
  {
    value: 'ordered-list',
    name: 'Numbered list',
    icon: NumberedList,
    type: ELEMENT_OL,
    subText: 'Make a list with numbers ',
  },
  {
    value: 'image-upload',
    name: 'Image',
    icon: ImageIcon,
    type: ELEMENT_IMAGE,
    subText: 'Upload an image',
  },
  {
    value: 'embed',
    name: 'Embed',
    icon: EmbedIcon,
    type: ELEMENT_EMBED,
    subText: 'For YouTube videos',
  },
  {
    value: 'file',
    name: 'File',
    icon: LinkFileIcon,
    type: ELEMENT_FILE,
    subText: 'Link a file',
  },
  {
    value: 'ai_content',
    name: 'AI Bot',
    icon: AiMagicToolIcon,
    type: ELEMENT_AI_CONTENT,
    subText: 'Generate content on the fly',
  },
  {
    value: 'date_today',
    name: 'Today',
    icon: DateIcon,
    type: ELEMENT_DATE_TODAY,
    subText: "Today's date",
  },
];

const _weaponsLMS = [
  {
    value: 'text',
    type: ELEMENT_DEFAULT,
    name: 'Text',
    icon: TextIcon,
    subText: 'Simply start typing',
  },
  {
    value: 'heading-1',
    name: 'Heading 1',
    icon: HeadingOneIcon,
    type: ELEMENT_H1,
    subText: 'For big headings',
  },
  {
    value: 'heading-2',
    name: 'Heading 2',
    icon: HeadingTwoIcon,
    type: ELEMENT_H2,
    subText: 'For medium headings',
  },
  {
    value: 'heading-3',
    name: 'Heading 3',
    icon: HeadingThreeIcon,
    type: ELEMENT_H3,
    subText: 'For small headings',
  },
  {
    value: 'bulleted-list',
    name: 'Bulleted list',
    icon: BulletedList,
    type: ELEMENT_UL,
    subText: 'Make pointers quickly',
  },
];

const _weaponsChat = [
  {
    value: 'text',
    type: ELEMENT_DEFAULT,
    name: 'Text',
    icon: TextIcon,
    subText: 'Simply start typing',
  },
  {
    value: 'heading-1',
    name: 'Heading 1',
    icon: HeadingOneIcon,
    type: ELEMENT_H1,
    subText: 'For big headings',
  },
  {
    value: 'heading-2',
    name: 'Heading 2',
    icon: HeadingTwoIcon,
    type: ELEMENT_H2,
    subText: 'For medium headings',
  },
  {
    value: 'heading-3',
    name: 'Heading 3',
    icon: HeadingThreeIcon,
    type: ELEMENT_H3,
    subText: 'For small headings',
  },
  {
    value: 'callout',
    name: 'Callout',
    icon: CalloutIcon,
    type: ELEMENT_CALLOUT_TIP,
    subText: 'Highlight a line',
  },
  {
    value: 'table-plus',
    name: 'Table',
    icon: TableIcon,
    type: ELEMENT_TABLE_PLUS,
    subText: 'Add a table to the page',
  },

  {
    value: 'codeblock',
    name: 'Code block',
    icon: CodeIcon,
    type: ELEMENT_CODE_HIGHLIGHT_BLOCK,
    subText: 'Write a piece of code ',
  },
  {
    value: 'blockquote',
    name: 'Quote',
    icon: BlockQuoteIcon,
    type: ELEMENT_BLOCKQUOTE,
    subText: 'Showcase a quote',
  },

  {
    value: 'bulleted-list',
    name: 'Bulleted list',
    icon: BulletedList,
    type: ELEMENT_UL,
    subText: 'Make pointers quickly',
  },
  {
    value: 'ordered-list',
    name: 'Numbered list',
    icon: NumberedList,
    type: ELEMENT_OL,
    subText: 'Make a list with numbers ',
  },
  {
    value: 'image-upload',
    name: 'Image',
    icon: ImageIcon,
    type: ELEMENT_IMAGE,
    subText: 'Upload an image',
  },
  {
    value: 'embed',
    name: 'Embed',
    icon: EmbedIcon,
    type: ELEMENT_EMBED,
    subText: 'For YouTube videos',
  },
];

export const WeaponsList = _weapons;
export const WeaponsListLMS = _weaponsLMS;
export const WeaponsListChat = _weaponsChat;

export const renderWeapons = {
  chat: WeaponsListChat,
  lms: WeaponsListChat,
  document: WeaponsList,
};
